<template>
  <div
    class="app__document"
    :class="{ _resizing: isResizing, _fullwidth: isFullFidth }"
  >
    <document-sidebar
      ref="sidebar"
      class="document__sidebar"
      :style="sidebarStyle"
      :card="card"
      :pages="pages"
      :current-view="currentView"
      :load-status="loadStatus"
      @change-active-section="onChangeActiveSection"
      @scan-page-click="onScanThumbnailClick"
      @change-content-view="handleChangeContentView"
    />

    <div class="document__resizer" @mousedown.prevent="startResize"></div>
    <div class="document__content">
      <div
        class="document__fullwidth"
        :title="
          isFullFidth ? 'Развернуть левую панель' : 'Свернуть левую панель'
        "
        @click="isFullFidth = !isFullFidth"
      >
        <svg width="24" height="24" class="document-fw__arrow">
          <use xlink:href="#chevron"></use>
        </svg>
        <svg width="26" height="26" class="document-fw__doc">
          <use xlink:href="#document"></use>
        </svg>
      </div>

      <document-toolbar
        :card="card"
        :current-view="currentView"
        @button-view-click="onToolbarButtonViewClick"
        @button-favorite-click="onButtonFavoriteClick"
        @button-watched-click="onButtonWatchedClick"
      />

      <document-viewer
        :fragmentId="fragmentId"
        :currentView="currentView"
        :searchMatches="searchMatches"
        :currentSearchMatch="currentSearchMatch"
        :pages="pages"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiApp from '@src/api/app';

import { mapGetters } from 'vuex';

import { SECTION_CARD, SECTION_THUMBNAILS } from '@@/document/DocumentSidebar';

import userSettings from '@src/storage/userSettings';

import DocumentSidebar from './DocumentSidebar';
import DocumentToolbar from './DocumentToolbar';
import DocumentViewer from './DocumentViewer';

export default {
  components: {
    DocumentSidebar,
    DocumentToolbar,
    DocumentViewer
  },

  data: () => ({
    fragmentId: null,
    currentView: 'card',
    sidebarActiveSectionKey: SECTION_CARD,
    isResizing: false,
    sidebarWidth: null,
    isFullFidth: false,
    searchMatches: {},
    currentSearchMatch: null
  }),

  computed: {
    ...mapGetters({
      documentId: 'currentDocumentId',
      card: 'currentDocumentInfo',
      pages: 'currentDocumentScans',
      loadStatus: 'documentIsLoading'
    }),
    hasFormatHtml() {
      return this.card && this.card.hasFormatHtml();
    },
    hasFormatScan() {
      return this.card && this.card.hasFormatScan();
    },
    hasAccessFull() {
      return this.card && this.card.hasAccessFull();
    },
    currentViewIsHtml() {
      return this.currentView === 'html';
    },
    currentViewIsScan() {
      return this.currentView === 'scan';
    },
    scanPagesIsOpened() {
      return (
        this.currentViewIsScan ||
        this.sidebarActiveSectionKey === SECTION_THUMBNAILS
      );
    },
    sidebarStyle() {
      return this.sidebarWidth !== null
        ? { width: `${this.sidebarWidth}px` }
        : null;
    }
  },

  watch: {
    $route: async function(to, from) {
      if (to.params && to.params.id) {
        if (to.params.id !== this.documentId) {
          await this.$store.dispatch('setCurrentDocumentId', to.params.id);
          await this.loadDocument();          
        }
      }
    }
  },

  async created() {
    // Обработка параметров URL при первом входе на страницу. Нужно для реализации возможности обмена
    // ссылками между пользователями и возврата по истории в браузере
    if (this.$route.params && this.$route.params.view) {
      this.currentView = this.$route.params.view;
    }
    if (this.$route.params && this.$route.params.id) {
      if (this.$route.params.id !== this.documentId) {
        await this.$store.dispatch(
          'setCurrentDocumentId',
          this.$route.params.id
        );
      }
    }
    await this.loadDocument();
  },

  async mounted(){
    if(this.currentView === 'views') {
     this.setFullWidth()
    }
  },

  methods: {
    setFullWidth(){
      this.isFullFidth = true
    },
    async loadDocument() {
      if (!this.documentId) this.$router.push({ name: 'home' });
      if (!Object.keys(this.card).length) {
        await this.$store.dispatch('setCurrentDocumentProperty', {
          name: 'info'
        });
      }
      if(+this.card.accessLevel === 1  && this.$route.params.view !== 'card') {
        this.$router.replace({
          name: 'document',
          params:{
            id: this.$route.params.id,
            view: 'card'
          }
        })

        return
      }

      // Текущий вид определяетя либо по параметрам пути, либо по иерархии: текст-скан-карточка
      if (this.$route.params && this.$route.params.view) {
        this.currentView = this.$route.params.view;
      } else {
        if (this.hasFormatHtml) {
          this.currentView = 'html';
        } else {
          if (this.hasFormatScan) this.currentView = 'scan';
        }
      }

      if (this.hasFormatScan) {        
        await this.$store.dispatch('setCurrentDocumentProperty', {
          name: 'scanPages'
        });
      }
      let scanContentPromise;
      let textContentPromise;
      let historyPromise;
      let discussionsPromise;
      let revisionsPromise;
      let attachmentsPromise;

      if (this.hasFormatScan) {
        scanContentPromise = this.$store.dispatch(
          'setCurrentDocumentProperty',
          { name: 'scanContent' }
        );
      }
      if (this.hasFormatHtml) {
        textContentPromise = this.$store.dispatch(
          'setCurrentDocumentProperty',
          { name: 'textContent' }
        );
      }
      historyPromise = this.$store.dispatch('setCurrentDocumentProperty', {
        name: 'history'
      });
      discussionsPromise = this.$store.dispatch('setCurrentDocumentProperty', {
        name: 'discussions'
      });
      revisionsPromise = this.$store.dispatch('setCurrentDocumentProperty', {
        name: 'revisions'
      });
      attachmentsPromise = this.$store.dispatch('setCurrentDocumentProperty', {
        name: 'attachments'
      });

      if (this.hasFormatScan) await scanContentPromise;
      if (this.hasFormatHtml) await textContentPromise;
      await historyPromise;
      await discussionsPromise;
      await revisionsPromise;
      await attachmentsPromise;
      this.sidebarWidth = userSettings.getDocumentSidebarWidth();
    },
    decodeHashToFragmentId(routeHash) {
      return routeHash ? decodeURIComponent(routeHash.slice(1)) : null;
    },
    onToolbarButtonViewClick(viewCode) {
      this.currentView = viewCode;
      if(this.currentView === 'views') {
        this.isFullFidth = true
      } else {
        this.isFullFidth = false
      }
      this.fragmentId = null;
      // Это нужно для формирования истории просмотра и возможности обмена ссылками
      this.$router.push({
        name: 'document',
        params: {
          id: this.documentId,
          view: viewCode
        },
        hash: ''
      });
    },
    startResize() {
      let sidebarElem = this.$refs.sidebar.$el,
        offsetLeft = sidebarElem.getBoundingClientRect().left;
      let resize = event => {
        sidebarElem.style.width = `${event.pageX - offsetLeft}px`;
      };
      let stopResize = () => {
        this.isResizing = false;
        window.removeEventListener('mousemove', resize);
        window.removeEventListener('mouseup', stopResize);

        this.sidebarWidth = sidebarElem.offsetWidth;
        userSettings.setDocumentSidebarWidth(sidebarElem.offsetWidth);
      };

      this.isResizing = true;
      window.addEventListener('mousemove', resize);
      window.addEventListener('mouseup', stopResize);
    },
    onChangeActiveSection(activeSectionKey) {
      this.sidebarActiveSectionKey = activeSectionKey;
    },
    onScanThumbnailClick(pageIndex) {
      this.currentView = 'scan';
      this.fragmentId = pageIndex;
      this.$router.push({
        name: 'document',
        params: {
          id: this.documentId,
          view: 'scan'
        },
        hash: `#${pageIndex}`
      });
    },
    async onButtonFavoriteClick(documentId, isFavorite) {
      try{
        await this.$store.dispatch('toggleDocumentAsFavorite', {
          documentId: documentId,
          isFavorite: !isFavorite
        });
      } catch(err) {
        console.error('Error on toggle document as favorite')
      }
    },
    async onButtonWatchedClick(documentId, isWatched) {
      await this.$store.dispatch('toggleDocumentAsWatched', {
        documentId: documentId,
        isWatched: !isWatched
      });
    },
    onSearchResult(matches, currentMatch) {
      this.searchMatches = matches;
      this.currentSearchMatch = currentMatch;
    },
    handleChangeContentView(viewObj) {
      this.currentView = viewObj.view;
      this.fragmentId = viewObj.hash.substr(1);
    },
  },

  metaInfo() {
    const types = {
      scan: 'Cкан',
      html: 'Текст',
      card: 'Карточка',
      views: 'Сравнение'
    };
    const typeWord = types[this.currentView];
    const title = this.card ? this.card.title : '';

    return {
      title: `[${typeWord}]: ${title}`
    };
  }
};
</script>

<style src="./styles/index.css" />
